import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for basicSharedLinkInfo query
 */
export interface BasicSharedLinkInfoVariables {
  linkId: string;
}

/**
 * Basic shared link info structure
 */
export interface BasicSharedLinkInfoData {
  id: string;
  expired: boolean;
  password: boolean;
}

/**
 * Response structure for basicSharedLinkInfo query
 */
export interface BasicSharedLinkInfoResponse {
  basicSharedLinkInfo: BasicSharedLinkInfoData;
}

const basicSharedLinkInfo: DocumentNode = gql`
  query basicSharedLinkInfo($linkId: String!) {
    basicSharedLinkInfo(linkId: $linkId) {
      id
      expired
      password
    }
  }
`;

export default basicSharedLinkInfo;
